// Elegibilidade do teste grátis, lida da LOJA (nunca presumida):
//   iOS     checkTrialOrIntroductoryPriceEligibility → ELIGIBLE (2)
//   Android o Google só entrega ao app as ofertas que a conta pode usar:
//           existir `defaultOption.freePhase` no pacote anual = elegível.
// UNKNOWN, erro ou web ⇒ NÃO elegível (mostra "Assinar anual", sem prometer
// teste que a loja pode recusar).

import { Capacitor } from '@capacitor/core';

const ELIGIBLE = 2;
let _cache = null;

function pacoteAnual(offering) {
  const pacotes = offering?.availablePackages || [];
  return (
    pacotes.find((p) => p.packageType === 'ANNUAL' || p.identifier === '$rc_annual')
    || null
  );
}

export async function verificarElegibilidadeTrial({ forcar = false } = {}) {
  if (!Capacitor.isNativePlatform()) return false;
  if (_cache !== null && !forcar) return _cache;
  try {
    const { Purchases } = await import('@revenuecat/purchases-capacitor');
    const offerings = await Purchases.getOfferings();
    const anual = pacoteAnual(offerings?.current);
    const produto = anual?.product;
    if (!produto) {
      _cache = false;
      return false;
    }
    if (Capacitor.getPlatform() === 'ios') {
      const r = await Purchases.checkTrialOrIntroductoryPriceEligibility({
        productIdentifiers: [produto.identifier],
      });
      const st = r?.[produto.identifier]?.status;
      _cache = st === ELIGIBLE && !!produto.introPrice && Number(produto.introPrice.price) === 0;
    } else {
      _cache = !!produto.defaultOption?.freePhase;
    }
  } catch {
    _cache = false;
  }
  return _cache;
}

export function esquecerElegibilidadeTrial() {
  _cache = null;
}
